import {
  DiscountType,
  PatchAppointmentDiscountPayload,
  PostAppointmentDiscountPayload,
} from "../../../apis/appointmentApi";
import { DiscountForm } from "./DiscountDrawer";

export function convertDiscountFormToPostPayload(values: DiscountForm) {
  const result: PostAppointmentDiscountPayload = {
    name: values.name,
    discountType: values.discountType.value,
    discountValue: values.discountValue,
    description: values.description,
    numberOfRebills: 1,
    appliesForever: true,
    appliesForXRebills: false,
  };
  return result;
}

export function convertDiscountFormToPathPayload(values: DiscountForm) {
  const result: PatchAppointmentDiscountPayload = {
    name: values.name,
    discountType: values.discountType.value,
    discountValue: values.discountValue,
    description: values.description,
  };
  return result;
}

export function convertToDiscountForm(
  discount: DiscountType,
  duplicate: boolean,
  discountTypeOptions: { value: string; label: string }[],
) {
  const name = duplicate ? `${discount.name} copy` : discount.name;
  const result: DiscountForm = {
    name,
    discountType: discountTypeOptions.find(
      (o) => o.value === discount.discountType,
    )!,
    discountValue: discount.discountValue,
    description: discount.description,
  };
  return result;
}
